const types = {
  RESET: 'app/contact/RESET',
  SEND: 'app/contact/SEND',
  SEND_SUCCESS: 'app/contact/SEND_SUCCESS',
  SEND_FAIL: 'app/contact/SEND_FAIL',
};

export default types;
